import { GradPlansCtrl } from './grad-plans.controller';

export const GradPlansStepComponent = {
  controller: GradPlansCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./grad-plans.html'),
};
